import React from "react";
import { useAutoplayOnceVideo } from "../lib/video.logic";

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };

  // UPDATED: include enableAudio + startedMuted
  const {
    videoRef,
    needsUserGesture,
    startedMuted,
    isPlaying,
    enableAudio,
    togglePlayPause,
  } = useAutoplayOnceVideo();

  // Overlay rule:
  // - If we started muted (desktop fallback) and need gesture => show "enable sound" overlay even if playing
  // - Otherwise show play overlay only when paused
  const showSoundOverlay = needsUserGesture && startedMuted;
  const showPlayOverlay = !isPlaying && !showSoundOverlay;

  const handleVideoClick = () => {
    if (showSoundOverlay) return enableAudio();
    return togglePlayPause();
  };

  return (
    <section id="hero" className="hero-gradient min-h-screen flex items-center justify-center pt-20">
      <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center">
        {/* Testo Hero */}
        <div className="fade-in-up">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-black mb-6">
            English Tutor
          </h1>
          <p className="text-xl md:text-2xl text-black mb-8 font-light leading-relaxed">
            Empowering students from Primary to Degree level with over 15 years of experience
          </p>
          <button
            onClick={scrollToContact}
            className="btn-primary px-8 py-4 rounded-full font-medium text-lg hover:scale-105 transition-transform"
          >
            Book a Consultation
          </button>
        </div>

        {/* Video */}
        <div className="fade-in-up">
          <div className="rounded-2xl overflow-hidden shadow-2xl relative">
            {/* Wrapper cliccabile */}
            <button
              type="button"
              onClick={handleVideoClick}
              className="block w-full text-left"
              aria-label={showSoundOverlay ? "Enable video sound" : "Toggle video play/pause"}
            >
              <video
                ref={videoRef}
                className="w-full h-[50vh] md:h-[60vh] object-cover pointer-events-none"
                playsInline
                preload="metadata"
                poster="/sharon_video_poster.jpg"
              >
                <source src="/sharon.video.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>

              {/* Overlay: Enable sound (when muted autoplay fallback happened) */}
              {showSoundOverlay && (
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-black/35 backdrop-blur-[2px] flex items-center justify-center">
                    {/* Speaker icon */}
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" className="opacity-90">
                      <path
                        d="M11 5L6.5 9H3v6h3.5L11 19V5z"
                        fill="white"
                        fillOpacity="0.9"
                      />
                      <path
                        d="M15.5 8.5a4.5 4.5 0 010 7"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        opacity="0.9"
                      />
                    </svg>
                  </span>
                </span>
              )}

              {/* Overlay: Play (only when paused) */}
              {showPlayOverlay && (
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-black/35 backdrop-blur-[2px] flex items-center justify-center">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" className="opacity-90">
                      <path d="M8 5v14l11-7L8 5z" fill="white" fillOpacity="0.9" />
                    </svg>
                  </span>
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
